import React from 'react';
import R from 'ramda';
import TextBlock from './text-dff';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

import Allocation from '../../../contracting/contract-activities-products/product/right-column/right-one';
export const AllocationDiff = ({ diff, isLeft, originalData }) => {
  const data = isLeft ? originalData.lhs : originalData.rhs;
  const classes = getClassesForType2(isLeft, diff, originalData, 'allocation', ['allotments', 'dateRanges']);
  return (
    <Allocation
      classes={classes}
      allocation={data}
    />
  )
};

import Blackouts from '../../../contracting/contract-activities-products/product/right-column/right-two-blackouts';
export const BlackoutsDiff = ({ diff, isLeft, originalData }) => {
  const data = isLeft ? originalData.lhs : originalData.rhs;
  return (
    <Blackouts
      classes={getClassesForType2(isLeft, diff, originalData, 'blackout', [])}
      blackouts={data}
    />
  )
};

import Season from '../../../contracting/contract-activities-products/product/left-column/season-for-seasonRates';
import RateTemplate from '../../../contracting/generic-components/rate-tables/rate-table-template-container';
export const SeasonRatesDiff = ({ isLeft, season, seasonName, rateSets, productType, kind }) => {
  const thisRateSets = R.pathOr([], ['originalData', isLeft ? 'lhs' : 'rhs'], rateSets);
  const thisDateRanges = R.pathOr([], ['originalData', isLeft ? 'lhs' : 'rhs'], season);
  if (kind === 'D' && !isLeft) return <div/>;
  if (kind === 'N' && isLeft) return <div/>;
  const mainClass = (() => {
    if (kind === 'D' || kind === 'N') return isLeft ? 'diff-block-deleted' : 'diff-block-added';
  })();
  const seasonClasses = (() => {
    return R.propOr([], 'diff', season).reduce((classes, { path, index, kind, item, ...extra }) => {
      if (!path) {
        if (!item) console.log({ kind, ...extra }, season);
        if (item && item.kind === 'D' && isLeft) classes[`${index}-dateRange`] = 'diff-deleted';
        if (item && item.kind === 'N' && !isLeft) classes[`${index}-dateRange`] = 'diff-added';
      } else {
        classes[path.join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
      }
      return classes;
    }, {});
  })();
  const rateSetsClasses = (() => {
    return getClassesForRatesEntities(isLeft, rateSets.diff, rateSets.originalData, 'rateSet', []);
  })();
  return (
    <div
      className={mainClass}
      style={{ marginTop: '16px', paddingTop: '8px' }}
    >
      {
        !isNilOrEmpty(thisDateRanges) && (<Season seasonName={seasonName} dateRanges={thisDateRanges} classes={seasonClasses}/>)
      }
      {
        thisRateSets.map((rateSet, rateSetsIndex) => {
          return (
            <RateTemplate
              productType={productType}
              key={rateSetsIndex}
              classes={R.merge(rateSetsClasses[`${rateSetsIndex}-ratesClasses`], { main: rateSetsClasses[`${rateSetsIndex}-rateSet`] })}
              rateSet={rateSet}
              rateSetsIndex={rateSetsIndex}
            />
          );
        })
      }
    </div>
  )
};

import Offers from '../../../contracting/contract-activities-products/product/left-column/left-four-offers';
export const OffersDiff = ({ diff, isLeft, originalData }) => {
  const thisClasses = (() => {
    const nonRateTableKeys = [
      'offerName', 'bookingCode', 'offerDetail', 'specialConditions', 'allowCombination', 'offerType',
      'isStayPay', 'stayPays', 'numberOfGuests', 'rate', 'discountType', 'amount', 'validDatesOfSale', 'validDatesOfTravel'
    ];
    return getClassesForRatesEntities(isLeft, diff, originalData, 'offer', nonRateTableKeys);
  })();
 const data = isLeft ? originalData.lhs : originalData.rhs;
 return (
   <Offers
     inDiffing
     offers={data}
     classes={thisClasses}
   />
 );
};

import Extras from '../../../contracting/contract-activities-products/product/left-column/left-extras';
export const ExtrasDiff = ({ diff, isLeft, originalData }) => {
  const extrasClasses = (() => {
    return getClassesForRatesEntities(isLeft, diff, originalData, 'extra', ['extraType', 'extraCode', 'description']);
  })();
  const data = isLeft ? originalData.lhs : originalData.rhs;
  return (
    <Extras
      hideHeader
      showBorder
      extras={data}
      classes={extrasClasses}
    />
  )
};

import { PickupDropoffDisplay } from '../../../contracting/contract-activities-products/product/right-column/right-four-pickup-dropoff';
export const PickupDropoffDiff = ({ diff, isLeft, originalData }) => {
  const data = isLeft ? originalData.lhs : originalData.rhs;
  const classes = getClassesForType2(isLeft, diff, originalData, 'pickupdropoff', ['timeLocArray', 'dateRanges']);
  return (
    <PickupDropoffDisplay
      arrayData={data}
      hideHeader
      classes={classes}
    />
  );
};


import PolicyMain from '../../../contracting/contract-activities-products/contract-policies/policies/policy-main';

export const ProductPolicyDiff = ({ diff, isLeft, originalData, type }) => {
  const thisClasses = getClassesForType2(isLeft, diff, originalData, 'prod-cancellation', ['dateRanges']);
  const data = isLeft ? originalData.lhs : originalData.rhs
  return (
    <PolicyMain
      policyType={type}
      policyProps={{
        hideLabel: true,
        classes: thisClasses,
        [`${type}Info`]: type === 'cancellation' ? { cancellations: data } : { ...data }
      }}
    />
  );
};

// Type 1: rateSets, offers, extras
const getClassesForRatesEntities = (isLeft, diff = [], originalData = {}, type, nonRateTableKeys) => {
  if (isNilOrEmpty(originalData.rhs) || isNilOrEmpty(originalData.lhs)) {
    if (isLeft) return { main: 'diff-block-deleted' };
    if (!isLeft) return { main: 'diff-block-added' };
  }
  return diff.reduce((classes, { path, index, kind, item, diffWords, ...extraArgs }) => {
    if (diffWords && diffWords.length) {
      classes[`${path.join('-')}-textblock`] = <TextBlock isLeft={isLeft} diffWords={diffWords} {...extraArgs} />;
    }
    if (!path) {
      if (item.kind === 'D' && isLeft) classes[`${index}-${type}`] = 'diff-block-deleted';
      if (item.kind === 'N' && !isLeft) classes[`${index}-${type}`] = 'diff-block-added';
    } else {
      const typeIndex = path[0];
      const subKey = path[1];
      if (nonRateTableKeys.indexOf(subKey) > -1) {
        classes[path.join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
      } else {
        if (!classes[`${typeIndex}-ratesClasses`]) classes[`${typeIndex}-ratesClasses`] = {};
        if (subKey === 'rates') {
          if (item) {
            if (item.kind === 'D' && isLeft) classes[`${typeIndex}-ratesClasses`][`${index}-rate`] = 'diff-deleted';
            if (item.kind === 'N' && !isLeft) classes[`${typeIndex}-ratesClasses`][`${index}-rate`] = 'diff-added';
          } else {
            classes[`${typeIndex}-ratesClasses`][path.slice(2, 8).join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
          }
        } else {
          classes[`${typeIndex}-ratesClasses`][path.slice(1, 8).join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
        }
      }
    }
    return classes;
  }, {});
}

// Type 2: allocation, pickup, dropoff, blackouts
export const getClassesForType2 = (isLeft, diff = [], originalData = {}, type, nestedArrayKeys = []) => {
  if (isNilOrEmpty(originalData.rhs) || isNilOrEmpty(originalData.lhs)) {
    if (isLeft) return { main: 'diff-block-deleted' };
    if (!isLeft) return { main: 'diff-block-added' };
  }
  return diff.reduce((classes, { path, index, kind, item, diffWords, ...extraArgs }) => {
    if (diffWords && diffWords.length) {
      classes[`${path.join('-')}-textblock`] = <TextBlock isLeft={isLeft} diffWords={diffWords} {...extraArgs} />;
    }
    if (!path && item) {
      if (item.kind === 'D' && isLeft) classes[`${index}-${type}`] = 'diff-block-deleted';
      if (item.kind === 'N' && !isLeft) classes[`${index}-${type}`] = 'diff-block-added';
    } else {
      const firstKey = path[0];
      const subKey = R.is(Number, firstKey) ? path[1] : path[0];
      if (nestedArrayKeys.indexOf(subKey) > -1 && item) {
        if (item.kind === 'D' && isLeft) classes[`${path.join('-')}-${index}`] = 'diff-deleted';
        if (item.kind === 'N' && !isLeft) classes[`${path.join('-')}-${index}`] = 'diff-added';
      } else {
        classes[path.join('-')] = isLeft ? 'diff-deleted' : 'diff-added';
      }
    }
    return classes;
  }, {});
};



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/ratePackage-elements.jsx